/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 483);
/******/ })
/************************************************************************/
/******/ ({

/***/ 483:
/***/ (function(module, exports) {

document.addEventListener("DOMContentLoaded", function (event) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    //do work
    (_a = document.getElementById('UserName')) === null || _a === void 0 ? void 0 : _a.addEventListener('focus', function () {
        document.getElementsByClassName('username-icon')[0].classList.add('active');
    });
    (_b = document.getElementById('Email')) === null || _b === void 0 ? void 0 : _b.addEventListener('focus', function () {
        document.getElementsByClassName('username-icon')[0].classList.add('active');
    });
    (_c = document.getElementById('Password')) === null || _c === void 0 ? void 0 : _c.addEventListener('focus', function () {
        document.getElementsByClassName('password-icon')[0].classList.add('active');
    });
    (_d = document.getElementById('ConfirmPassword')) === null || _d === void 0 ? void 0 : _d.addEventListener('focus', function () {
        document.getElementsByClassName('confirm-password-icon')[0].classList.add('active');
    });
    (_e = document.getElementById('UserName')) === null || _e === void 0 ? void 0 : _e.addEventListener('blur', function () {
        document.getElementsByClassName('username-icon')[0].classList.remove('active');
    });
    (_f = document.getElementById('Email')) === null || _f === void 0 ? void 0 : _f.addEventListener('blur', function () {
        document.getElementsByClassName('username-icon')[0].classList.remove('active');
    });
    (_g = document.getElementById('Password')) === null || _g === void 0 ? void 0 : _g.addEventListener('blur', function () {
        document.getElementsByClassName('password-icon')[0].classList.remove('active');
    });
    (_h = document.getElementById('ConfirmPassword')) === null || _h === void 0 ? void 0 : _h.addEventListener('blur', function () {
        document.getElementsByClassName('confirm-password-icon')[0].classList.remove('active');
    });
});


/***/ })

/******/ });


// WEBPACK FOOTER //
// login.js